/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
    Flex,
    Heading,
    Input,
    Button,
    InputGroup,
    Stack,
    InputLeftElement,
    chakra,
    Box,
    Avatar,
    FormControl,
    FormHelperText,
    InputRightElement,
    Text,
    Spinner,
    Center
} from "@chakra-ui/react";
import { useCreateUserWithEmailAndPassword } from 'react-firebase-hooks/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, firestore } from "../../../utils/firebase";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from 'uuid';

import { FaUserAlt, FaLock } from "react-icons/fa";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect
} from "react-router-dom";
import { DataContext } from "../../../state/DataContext/DataContext";
import RedirectIfLoggedIn from "../../Shared/RedirectIfLoggedIn/RedirectIfLoggedIn";
import { firebase } from 'firebase';

const CFaUserAlt = chakra(FaUserAlt);
const CFaLock = chakra(FaLock);

const Signup = () => {

    const [
        createUserWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useCreateUserWithEmailAndPassword(auth);

    const [myUser] = useAuthState(auth);

    const [showPassword, setShowPassword] = React.useState(false);
    const [userData, setUserData] = React.useState();

    const { data, actions } = React.useContext(DataContext);

    React.useEffect(() => {
        // After user is signed up, we save the data and then <RedirectIfLoggedIn/> will check if data exist before redirecting
        if (user && user.additionalUserInfo.isNewUser) {

            const batch = firestore.batch();

            let usersRef = firestore.collection('users')
                .doc(user.user?.uid);

            let tenantsRef = firestore.collection('tenants')
                .doc(userData.TenantID);


            batch.set(usersRef, { ...userData, uid: user.user?.uid });
            batch.set(tenantsRef, {
                BusinessName: userData.BusinessName,
                TenantID: userData.TenantID,
                BusinessOwnerName: userData.Name
            });
            batch.commit();
        }

    }, [user])

    const handleShowClick = () => setShowPassword(!showPassword);

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const onSubmit = data => {
        setUserData({
            Email: data.email,
            TenantID: uuidv4(),
            BusinessName: data.BusinessName,
            Name: data.Name,
            Role: "Admin"
        })
        createUserWithEmailAndPassword(data.email, data.password)

    }

    return (
        <Flex
            flexDirection="column"
            width="100wh"
            height="100vh"
            backgroundColor="gray.50"

            justifyContent="center"
            alignItems="center"
        >
            <RedirectIfLoggedIn />
            <Stack
                flexDir="column"
                mb="2"
                justifyContent="center"
                alignItems="center"
            >
                <Heading fontSize={'4xl'}><Text display="inline" fontWeight="black" color="green.500">Job</Text><Text display="inline" fontWeight="bold">WorkPad</Text></Heading>
                <Text textAlign={"center"} fontSize={'lg'} color={'gray.600'} fontWeight="semibold">
                    Manage, schedule and create checklists <br />with JobWorkPad. <br />

                </Text>
                <Heading color="green.400">Let's Get You Started</Heading>
                <Box minW={{ base: "90%", md: "420px" }}>
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <Stack
                            spacing={4}
                            p="1rem"
                            backgroundColor="white"
                            boxShadow="md"
                            borderRadius="0.5em"
                        >
                            {loading ? <Center height="200px"><Spinner /></Center> :
                                <>
                                    {error?.message}
                                    <FormControl>
                                        <InputGroup>
                                            <Input placeholder="Name" {...register("Name", { required: true })} />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl>
                                        <InputGroup>
                                            <Input placeholder="Business Name" {...register("BusinessName", { required: true })} />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                children={<CFaUserAlt color="gray.300" />}
                                            />
                                            <Input type="email" placeholder="email" {...register("email", { required: true })} />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                color="gray.300"
                                                children={<CFaLock color="gray.300" />}
                                            />
                                            <Input type={showPassword ? "text" : "password"} placeholder="Password" {...register("password", { required: true })} />
                                            <InputRightElement width="4.5rem">
                                                <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                                                    {showPassword ? "Hide" : "Show"}
                                                </Button>
                                            </InputRightElement>
                                        </InputGroup>
                                        <FormHelperText textAlign="right">
                                            {/* <Link>forgot password?</Link> */}
                                        </FormHelperText>
                                    </FormControl>
                                </>
                            }

                            <Button
                                type="submit"
                                borderRadius={0}
                                variant="solid"
                                colorScheme="green"
                                width="full"
                            >
                                Sign Up
                            </Button>
                        </Stack>
                    </form>
                </Box>
            </Stack>
            <Box>
                <Flex>
                    <Text marginRight="5px">
                        Already have an account?{" "}
                    </Text>
                    <Link to="/login">
                        <Text color="green.500" >Login </Text>
                    </Link>
                </Flex>

            </Box>
        </Flex>
    );
};

export default Signup;
